import * as React from "react";
import { CoreTheme } from "sharedUI/styles";
import styled, { useTheme } from "styled-components";

// Some random string to number hash I found.
export function stringToHash(string: string): number {
    let hash = 0;

    for (let i = 0; i < string.length; i++) {
        const char = string.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }

    return hash;
}

export function useColorFromSeed(seed: string): string {
    const theme = useTheme() as CoreTheme;

    const colors = [
        theme.newBrand1,
        theme.newBrand2,
        theme.newBrand3,
        theme.newBrand4,
        theme.newBrand5,
        theme.newBrand6,
        theme.newBrand7,
    ];

    const index = Math.abs(stringToHash(seed)) % colors.length;

    return colors[index];
}

const AlternateImageStyle = styled.div<{ color: string }>`
    width: 20px;
    height: 20px;
    margin-right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${p => p.color};
    position: relative;

    ::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        background-color: ${p => p.color};
        opacity: 0.15;
    }

    .initial-letter {
        font-size: 12px;
    }
`;

interface Props {
    readonly name: string;
}

export const UserPreviewIcon: React.VFC<Props> = p => {
    const color = useColorFromSeed(p.name);

    return (
        <AlternateImageStyle className="alternate-user-image" color={color}>
            <span className="initial-letter">{p.name[0]?.toUpperCase()}</span>
        </AlternateImageStyle>
    );
};
